import { atom } from 'recoil';

export const groupAtom = atom({
  key: 'groupAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});